import { Injectable } from "@angular/core";
import { RadioCheckBoxEnum } from "../../../../common/radio.checkbox.enums";
import { CommunicationFNSSimple } from "../../models/CommunicationFNSSimple";
import { Non } from "../../models/Non";
import { Oui } from "../../models/Oui";
import { UrlSecurite } from "../../models/UrlSecurite";
import { DocSecurite } from "../../models/DocSecurite";

@Injectable({
    providedIn: 'root'
})
export class CommunicationService {

    constructor() { }

    getCommunication(controls): CommunicationFNSSimple {

        const communication = new CommunicationFNSSimple();
        const url = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepAtt_urlProfilAch_radio');

        if (url === RadioCheckBoxEnum.urlProfilAchValue) {
            communication.urlProfilAch = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepAtt_urlProfilAch');
            communication.urlDocConsul = null;
            communication.autre = null;
        }
        if (url === RadioCheckBoxEnum.urlDocConsulValue) {
            communication.urlProfilAch = null;
            communication.urlDocConsul = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepAtt_urlDocConsul');
            communication.autre = null;
        }
        if (url === RadioCheckBoxEnum.autreValue) {
            communication.urlProfilAch = null;
            communication.urlDocConsul = null;
            communication.autre = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepAtt_autre');
        }
        communication.identifiantInterne = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepAtt_identifiantInterne');
        communication.adresseMailContact = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepAtt_adresseMailContact');
        communication.nomContact = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepAtt_nomContact');
        communication.telContact = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepAtt_telContact');

        communication.urlSecurite = new UrlSecurite();
        if(controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepSep_UrlSecurite_SepAtt_non') === 'Non') {
            communication.urlSecurite.oui = null;
            communication.urlSecurite.non = RadioCheckBoxEnum.emptyValue;
        } else if (controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepSep_UrlSecurite_SepAtt_non') === 'Oui'){
            communication.urlSecurite.oui = new Oui();
            communication.urlSecurite.oui.mesuresConfurlConfidentialite = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepSep_UrlSecurite_SepSep_Oui_SepAtt_mesuresConfurlConfidentialite');
            communication.urlSecurite.non = null;
        } else {
            communication.urlSecurite.oui = null;
            communication.urlSecurite.non = null;
        }

        communication.docSecurite = new DocSecurite();
        if(controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepSep_DocSecurite_SepAtt_oui') === 'Oui') {
            communication.docSecurite.non = null;
            communication.docSecurite.oui = RadioCheckBoxEnum.emptyValue;
        } else if (controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepSep_DocSecurite_SepAtt_oui') === 'Non') {
            communication.docSecurite.oui = null;
            communication.docSecurite.non = new Non();
            communication.docSecurite.non.mesuresConfidentialite = controls.get('_SepSep_Initial_SepSep_CommunicationFNSSimple_SepSep_DocSecurite_SepSep_Non_SepAtt_mesuresConfidentialite');
        } else {
            communication.docSecurite.oui = null;
            communication.docSecurite.non = null;
        }

        return communication;
    }
}
